import React from 'react';

import NavigationBreadcrumbs from '../../Common/NavigationBreadcrumbs';
import PageHeader from '../../Common/PageHeader';

import { getBillingDashboardPageBreadcrumb } from '../Billing/BillingDashboardPage';
import PageContent from '../PageContent';
import CreditPanelConfig from './Config/CreditPanelConfig';

import { getCreditListPageBreadcrumb } from './CreditListPage';
import CreditPanel from './CreditPanel';

class CreditDetailPage extends React.Component {
  state = {
    creditNewMode: false
  };

  creditId;
  facilityId;

  constructor(props) {
    super(props);

    const urlSearchParams = new URLSearchParams(window.location.search);
    this.facilityId = urlSearchParams.get('facility');
    this.creditId = urlSearchParams.get('credit');

    this.state.creditNewMode = !this.creditId;
  }

  renderNavigationBreadcrumbs() {
    const breadcrumbs = [];
    breadcrumbs.push(getBillingDashboardPageBreadcrumb(false, this.facilityId));
    breadcrumbs.push(getCreditListPageBreadcrumb(false, this.facilityId));
    breadcrumbs.push(getCreditListPageBreadcrumb());

    return <NavigationBreadcrumbs breadcrumbs={breadcrumbs} />;
  }

  renderPageHeader() {
    const heading = 'Credit Detail';
    return <PageHeader heading={heading} actions={[]} />
  }

  renderCredit(config) {
    const {
      creditNewMode
    } = this.state;

    return (
      <CreditPanel
        newMode={creditNewMode}
        config={config}
      />
    );
  }

  render() {
    const {
      creditNewMode
    } = this.state;

    return (
      <div className="parkchirp--page parkchirp--page--credit-detail">
        {this.renderNavigationBreadcrumbs()}
        {this.renderPageHeader()}
        <div className="parkchirp--page-content">
          <div className="parkchirp--page--credit-detail--main-content-container">
            <PageContent
              config={new CreditPanelConfig({ newMode: creditNewMode, creditId: this.creditId, facilityId: this.facilityId })}
              errorMessage="The following errors occurred while retrieving the credit:"
              loadingMessage="Retrieving credit, please wait..."
              className={`parkchirp--credit-panel${(creditNewMode) ? ' parkchirp--credit-panel--new' : ''}`}
              renderContent={config => this.renderCredit(config)}
            />
          </div>
        </div>
      </div>
    )
  }
}

export function getCreditDetailPageBreadcrumb(currentPage = true, creditId = null, facilityId = null) {
  const title = 'Credit';
  const href = (currentPage) ? null :
    `?page=parkchirp_credit${creditId ? `&credit=${creditId}` : ''}${facilityId ? `&facility=${facilityId}` : ''}`;

  return { title, href };
}

export default CreditDetailPage;